import React, { Component } from 'react'
// import { HeaderData } from '../../../../screens/reporting/styles';
import styled from 'styled-components';
import { colors } from '../../../../common/styles';
import { dimensions } from '../../../../common/styles';
const HeaderData = styled.div`
  // background: ${props =>
    props.background === 'transparent' ? 'none' : colors[props.background]};
  // background: rgba(40, 166, 222, 0.05);
  // min-height: ${dimensions.headerSpacing}px;
  // height: ${dimensions.headerSpacing}px;
  // border-top-left-radius: 20px;
  // border-top-right-radius: 20px;
  // border-bottom: 1px solid ${colors.borderPrimary};
  // display: flex;
  // justify-content: space-between;
  // padding: 12px;
  // // margin: 20px;
  // border-radius: 9px;

  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px;
  background: #f4fafd;

  h6 {
    font-weight: 700;
    font-size: 24px;
    line-height: 33px;
    letter-spacing: 0.2em;
    text-transform: uppercase;
  }

  label {
    color: ${colors.themeBlack};
    margin: 0px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.5px;
  }

  .filter-header-bar {
    padding: 12px 15px 12px 19px;
    // left: -58px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }
`;

class ReportFilterHeaderTheme extends Component {

    render() {
        const { filterCloseOnClick } = this.props;
        return (
            <HeaderData>
                <h6>Filter</h6>
                <div className="filter-header-bar" onClick={filterCloseOnClick} style={{ cursor: 'pointer', zIndex: '999' }}>
                    <span class="material-symbols-outlined">
                        cancel
                    </span>
                </div>

            </HeaderData>
        )
    }
}

export default ReportFilterHeaderTheme


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/ReportFilterHeaderTheme.js